import { createSelector as reselectCreateSelector } from 'reselect';
import { logStackTrace } from '@shared/utils/logStackTrace.js';

const debug = false;

const data = {
  totalTime: 0,
  selectors: {}
};

if (debug) {
  setInterval(() => {
    console.log(`Ms: ${data.totalTime}, Selectors:`, data.selectors);
    data.totalTime = 0;
    data.selectors = {};
  }, 3000);
}

export const createSelector = (...args) => {
  let title;
  if (typeof args[0] === 'string') {
    title = args[0];
    args = args.slice(1);
  } else {
    console.log('Missing selector name');
    logStackTrace(100);
  }

  const resultFuncIndex = args.length - 1;
  const originalResultFunc = args[resultFuncIndex];

  if (debug) {
    args[resultFuncIndex] = (...params) => {
      const start = performance.now();
      const result = originalResultFunc(...params);
      const duration = performance.now() - start;
      data.totalTime += duration;
      data.selectors[title || 'Unknown'] = (data.selectors[title || 'Unknown'] || 0) + 1;
      data.selectors['###total'] = (data.selectors['###total'] || 0) + 1;
      return result;
    };
  }

  return reselectCreateSelector(...args);
};
